export var IntelligentPhotoCaptureSeverityType;
(function (IntelligentPhotoCaptureSeverityType) {
    IntelligentPhotoCaptureSeverityType["FATAL"] = "FATAL";
    IntelligentPhotoCaptureSeverityType["NONFATAL"] = "NONFATAL";
    IntelligentPhotoCaptureSeverityType["WARNING"] = "WARNING";
})(IntelligentPhotoCaptureSeverityType || (IntelligentPhotoCaptureSeverityType = {}));
//# sourceMappingURL=IntelligentPhotoCaptureSeverityType.js.map